import axios from 'axios'
import auth from '@/services/auth.service'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

// intercept http request
axios.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('accessToken');

    if (token) {
      config.headers['authorization'] = token;
    }
    config.headers['Content-Type'] = 'application/json';

    return config;
  },

  (error) => {
    console.log(error)
    return Promise.reject(error);
  }
);

// intercept http response
axios.interceptors.response.use(
  (response) => {
    return response
  },

  (error) => {
    if (error.response) {
      if (error.response.status === 403 && error.response.data.msgOn === 'Verify Token') {
        auth.redirect()
        return
      } else if (error.response.status === 404) {
        // BE return 404 if data is empty,
        // we have to assign "data" prop with empty array
        error.response.data.msgContent = {}
        error.response.data.msgContent['data'] = []
        return Promise.resolve(error.response)
      } else {
        // Do something with response error
        return Promise.reject(error)
      }
    }
  }
);

const server = {
  get: (url, params) => {
    return axios.get(url, { params: params })
  },
  post: (url, payload) => {
    return axios.post(url, payload)
  },
  patch: (url, payload) => {
    return axios.patch(url, payload)
  },
  delete: (url, param) => {
    return axios.delete(url, { data: param })
  }
}

export default server;
